export default theme => ({
  button: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 20,
  },
  button_container: {
    display: "flex",
  },
});
